import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemApiClient } from '../clients/system-api/SystemApiClientp';
import { AddPriorityWorkDayConfig, AddPriorityWorkDayConfigs, AddScheduleData, AdministrationResultStatus, DailyAvailabilityArgs, DateTimeAvailabilityDataDictionaryAdministrationResult, PriorityWorkDayConfigData, PriorityWorkDayConfigDataListAdministrationResult, ReplaceEmployeeData, ScheduleDataAdministrationResult, ScheduleDataListAdministrationResult } from '../clients/system-api/SystemApiClient';
@Injectable({
  providedIn: 'root'
})
export class PriorityWorkDayConfigService {
  constructor(private systemApiClient: SystemApiClient) { }

  replaceEmployeeWithAddingPriorityWDC(body: ReplaceEmployeeData | undefined): Observable<AdministrationResultStatus>  {
    return this.systemApiClient.replaceEmployeeWithAddingPriorityWDC(body);
  }

  addPriorityWorkDayConfigs(removeExist: boolean | undefined, body: AddPriorityWorkDayConfigs | undefined): Observable<AdministrationResultStatus>  {
    return this.systemApiClient.addPriorityWorkDayConfigs(removeExist, body);
  }

  addPriorityWorkDayConfig(employeeProfileId: number | undefined, body: AddPriorityWorkDayConfig | undefined): Observable<AdministrationResultStatus>  {
    return this.systemApiClient.addPriorityWorkDayConfig(employeeProfileId, body);
  }

  updatePriorityWorkDayConfig(body: PriorityWorkDayConfigData | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.updatePriorityWorkDayConfig(body);
  }

  retrieveAllPriorityWorkDayConfigs(): Observable<PriorityWorkDayConfigDataListAdministrationResult> {
    return this.systemApiClient.retrieveAllPriorityWorkDayConfigs();
  }

  removeScheduleForDayByAddingPriorityWDC(removeExist: boolean | undefined, body: AddPriorityWorkDayConfigs | undefined): Observable<AdministrationResultStatus>  {
    return this.systemApiClient.removeScheduleForDayByAddingPriorityWDC(removeExist, body);
  }
}